import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import qrcode from "qrcode";

function PublicResearchPositionOverview(props) {

  const { researchPosition } = props;
  const positionQR = useRef(null);

  const getFacultyWebsite = () => {
    const body = new FormData();
    body.append("positionId", researchPosition.positionId);
    body.append("facultyId", researchPosition.facultyId);
    axios.post("/faculty/getResearchPositionFacWebsite", body).then((res) => {
      const data = res.data;
      setFacultyWebsite(data.website);
    });
  };

  const [facultyWebsite, setFacultyWebsite] = React.useState(getFacultyWebsite());
  useEffect(() => {
    if(positionQR.current) {
        const canvasEl = positionQR.current;
        console.log("Creating the QR code!?!?!?!?");
        qrcode.toCanvas(canvasEl, `https://jobhub.cs.vt.edu/researchpositions?jid=${researchPosition.positionId}`, function(error, canvas) {
            if(error) {
                console.log(`Couldn't generate and apply QR code: ${error}`);
                canvasEl.style.display = "none";
            }
            console.log("CREATED QR CODE???");
        });
    } else {
        console.log("Couldn't find the Canvas?");
    }
  }, [researchPosition]);
    
  if (Object.keys(researchPosition).length === 0) {
    return;
  }
  return (
    <div className="ResearchPositionOverview-container rounded-xl bg-white p-6 h-full overflow-y-auto">
      <canvas id="positionQR" className="qrcode-image" ref={positionQR} style={{ float: "right" }}></canvas>
      <div className="ResearchPositionOverview-type text-base mb-3 font-brand-primary flex">
        <div className="ResearchPositionOverview-detailsTitle text-base mr-1 font-brand-primary whitespace-nowrap">
          {
            Array.isArray(researchPosition.researchPositionCompensation) ?
            researchPosition.researchPositionCompensation.join(", ") :
            researchPosition.researchPositionCompensation
          }
        </div>
        •
        <div className="ResearchPositionOverview-detailsTitle text-base mx-1 font-brand-primary whitespace-nowrap">
          {
            Array.isArray(researchPosition.researchPositionType) ?
            researchPosition.researchPositionType.join(", ") :
            researchPosition.researchPositionType
          }
        </div>
        •
        <div className="ResearchPositionOverview-detailsTitle text-base ml-1 font-brand-primary">
          {
            Array.isArray(researchPosition.researchPositionResearchArea) ?
            researchPosition.researchPositionResearchArea.join(", ") :
            researchPosition.researchPositionResearchArea
          }
        </div>
      </div>
      <div className="ResearchPositionOverview-title text-4xl font-bold mb-4  font-brand-primary">
        {researchPosition.title}
      </div>
      <div className="ResearchPositionOverview-company text-base mb-3 font-brand-primary">
        <span style={{ fontWeight: "bold" }}>Faculty Member:</span>
        <span style={{ marginLeft: "4px" }}>{researchPosition.facultyName}</span>
      </div>
      {(facultyWebsite !== "" && facultyWebsite !== undefined) && (

        <div className="Project-Link mb-3 font-brand-primary justify-start py-auto">
          <span style={{ fontWeight: "bold" }}>Faculty Website: </span> &nbsp;
          <a href={facultyWebsite.startsWith("http://") || facultyWebsite.startsWith("https://")
            ? facultyWebsite
            : `http://${facultyWebsite}`} target="_blank" rel="noreferrer"
            style={{ color: "#0000EE", cursor: "pointer", background: "none", border: "none", padding: 0, textDecoration: "underline" }}
            onMouseOver={(e) => e.currentTarget.style.color = "#551A8B"}
            onMouseOut={(e) => e.currentTarget.style.color = "#0000EE"}>
            {facultyWebsite.startsWith("http://") || facultyWebsite.startsWith("https://")
              ? facultyWebsite
              : `http://${facultyWebsite}`}
          </a>
        </div>
      )}
      <div className="ResearchPositionOverview-detailsContainer">
        <div className="ResearchPositionOverview-detailsTitle text-xl font-bold mb-2 font-brand-primary">
          Research Position Details
        </div>
        <div className="ResearchPositionOverview-detailsDescription text-base mb-3 font-brand-primary">
          {researchPosition.details}
        </div>
      </div>
      {(researchPosition.projectURL !== "") && (

        <div className="Project-Link mb-3 font-brand-primary justify-start py-auto">
          <span style={{ fontWeight: "bold" }}>Project Link: </span> &nbsp;
          <a href={researchPosition.projectURL.startsWith("http://") || researchPosition.projectURL.startsWith("https://")
            ? researchPosition.projectURL
            : `http://${researchPosition.projectURL}`} target="_blank" rel="noreferrer"
            style={{ color: "#0000EE", cursor: "pointer", background: "none", border: "none", padding: 0, textDecoration: "underline" }}
            onMouseOver={(e) => e.currentTarget.style.color = "#551A8B"}
            onMouseOut={(e) => e.currentTarget.style.color = "#0000EE"}>
            {researchPosition.projectURL.startsWith("http://") || researchPosition.projectURL.startsWith("https://")
              ? researchPosition.projectURL
              : `http://${researchPosition.projectURL}`}
          </a>
        </div>
      )}
      <div className="ResearchPositionOverview-infoContainer">
        <div className="ResearchPositionOverview-postedContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            Date Posted:
          </div>
          <div className="ResearchPositionOverview-postedDescription text-base mb-3 font-brand-primary">
            {researchPosition.startDate}
          </div>
        </div>
        <div className="ResearchPositionOverview-dueDateContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            Application Deadline:
          </div>
          <div className="ResearchPositionOverview-dueDateDescription text-base mb-3 font-brand-primary">
            {researchPosition.endDate}
          </div>
        </div>
        <div className="ResearchPositionOverview-compensationContainer">
          <div className="JobOverview-compensationTitle text-xl font-bold mb-2 font-brand-primary">
            Compensation:
          </div>
          <div className="ResearchPositionOverview-compensationDescription text-base mb-3 font-brand-primary">
            {Array.isArray(researchPosition.researchPositionCompensation) ? researchPosition.researchPositionCompensation.join(" ") : researchPosition.researchPositionCompensation}
          </div>
        </div>
        <div className="ResearchPositionOverview-jobTypeContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            Position Type:
          </div>
          <div className="ResearchPositionOverview-postedDescription text-base mb-3 font-brand-primary">
            {Array.isArray(researchPosition.researchPositionType) ? researchPosition.researchPositionType.join(", ") : researchPosition.researchPositionType}
          </div>
        </div>
        <div className="ResearchPositionOverview-researchAreaContainer">
          <div className="JobOverview-postedTitle text-xl font-bold mb-2 font-brand-primary">
            Research Area(s):
          </div>
          <div className="ResearchPositionOverview-postedDescription text-base mb-3 font-brand-primary">
            {Array.isArray(researchPosition.researchPositionResearchArea) ?
            researchPosition.researchPositionResearchArea.join(", ") :
            researchPosition.researchPositionResearchArea}
          </div>
        </div>
        <div className="ResearchPositionOverview-skillsContainer">
          {(researchPosition.skills.length > 0) && <div className="ResearchPositionOverview-skillsTitle text-xl font-bold mb-2 font-brand-primary">
            Skills
          </div>}
          <div className="ResearchPositionOverview-skillsDescription text-base mb-3 font-brand-primary">
            {Array.isArray(researchPosition.skills) ? researchPosition.skills.join(", ") : researchPosition.skills}
          </div>
        </div>
      </div>
    </div>
  );
}

PublicResearchPositionOverview.propTypes = {
  researchPosition: PropTypes.shape({
    apply: PropTypes.bool,
    positionId: PropTypes.number,
    title: PropTypes.string,
    location: PropTypes.string,
    facultyName: PropTypes.string,
    facultyId: PropTypes.number,
    details: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    projectURL: PropTypes.string,
    researchPositionType: PropTypes.arrayOf(PropTypes.string),
    researchPositionCompensation: PropTypes.arrayOf(PropTypes.string),
    researchPositionResearchArea: PropTypes.arrayOf(PropTypes.string),
    skills: PropTypes.arrayOf(PropTypes.string),
    viewCount: PropTypes.number,
    applyCount: PropTypes.number,
    favorited: PropTypes.string,
  })
};

PublicResearchPositionOverview.defaultProps = {
  researchPosition: {},
};

export default PublicResearchPositionOverview;
